import { COMPONENT_TYPE, INPUT_COMPONENT_TYPE, MODULE_TYPE } from '@abiglobalhealth/go-types'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/Button'
import { Input } from '@/components/Input'
import { useButtonClick } from '@/hooks/useButtonClick'
import { useConversationSummaryPrefill } from '@/hooks/useConversationSummaryPrefill'
import { useModule } from '@/hooks/useModule'

const MIN_QUESTION_LENGTH = 50

export const PrescriptionForm = () => {
  const { t } = useTranslation()
  const { handleButtonClick } = useButtonClick()
  const { currentModule } = useModule()
  const { updateSummary, isFetchingSummary } = useConversationSummaryPrefill()

  if (currentModule?.type !== MODULE_TYPE.CONSULTATION_LANDING) return null

  const createConsultation = async () => {
    handleButtonClick(currentModule.buttonAction)
  }

  useEffect(() => {
    updateSummary()
  }, [updateSummary])

  return (
    <div className="flex grow flex-col gap-6" data-testid="prescription-form-container">
      <h3>{t('general.prescriptionRequest.question.title')}</h3>

      <div className="flex max-h-52 grow">
        <Input
          id="question"
          componentType={COMPONENT_TYPE.INPUT}
          tabIndex={0}
          type={INPUT_COMPONENT_TYPE.TEXTAREA}
          placeholder={isFetchingSummary ? 'loading_summary' : 'general.prescriptionRequest.question.placeholder'}
          minLength={MIN_QUESTION_LENGTH} // Follow up doesn't require a minimum length
          required
          disabled={isFetchingSummary}
        />
      </div>

      <Button onClick={createConsultation} disabled={isFetchingSummary}>
        {t('button.continue')}
      </Button>

      <span className="text-sm">{t('general.prescriptionRequest.question.hint')}</span>
    </div>
  )
}
